import { render } from "./Medias.vue?vue&type=template&id=4168b5b8&ts=true"
import script from "./Medias.vue?vue&type=script&lang=ts"
export * from "./Medias.vue?vue&type=script&lang=ts"

import "./Medias.vue?vue&type=style&index=0&id=4168b5b8&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__